(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roseford-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('roseford-cart-drawer')) {
    customElements.define('roseford-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.rf-drawer__panel');
        this.items = this.querySelector('[data-drawer-items]');
        this.footer = this.querySelector('[data-drawer-footer]');
        this.status = this.querySelector('[data-drawer-status]');
        document.addEventListener('click', (event) => this.handleClick(event));
        document.addEventListener('submit', (event) => this.handleSubmit(event));
        document.addEventListener('change', (event) => this.handleChange(event));
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
      }
      handleChange(event) {
        const select = event.target.closest('[data-quick-variant]');
        if (!select) return;
        const button = select.closest('[data-recommendation]')?.querySelector('[data-quick-add]');
        if (button) button.dataset.quickAdd = select.value;
      }
      async handleClick(event) {
        const open = event.target.closest('[data-cart-drawer-open]');
        if (open) { event.preventDefault(); await this.open(); return; }
        if (event.target.closest('[data-drawer-close]')) { this.close(); return; }
        const quantity = event.target.closest('[data-cart-quantity]');
        if (quantity) await this.change(quantity.dataset.key, Number(quantity.dataset.quantity));
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) await this.change(remove.dataset.key, 0);
        const quickAdd = event.target.closest('[data-quick-add]');
        if (quickAdd) await this.add({ id: quickAdd.dataset.quickAdd, quantity: 1 }, quickAdd);
      }
      async handleSubmit(event) {
        const form = event.target.closest('form[action*="/cart/add"]');
        if (!form || form.closest('roseford-cart-drawer')) return;
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        if (button) button.disabled = true;
        try {
          const response = await fetch(`${form.action}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Unable to add item');
          await this.open();
        } catch (error) { this.status.textContent = error.message; }
        if (button) button.disabled = false;
      }
      async add(item, button) {
        button.disabled = true;
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(item) });
        if (response.ok) { await this.refresh(); this.status.textContent = 'Item added to bag.'; }
        button.disabled = false;
      }
      async change(key, quantity) {
        const response = await fetch(this.dataset.changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        if (response.ok) this.render(await response.json());
      }
      async open() { await this.refresh(); this.classList.add('is-open'); this.panel.setAttribute('aria-hidden', 'false'); document.body.classList.add('rf-drawer-lock'); this.querySelector('[data-drawer-close]')?.focus(); }
      close() { this.classList.remove('is-open'); this.panel.setAttribute('aria-hidden', 'true'); document.body.classList.remove('rf-drawer-lock'); }
      async refresh() { const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }); if (response.ok) this.render(await response.json()); }
      money(value, currency) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(value / 100); }
      escape(value = '') { const node = document.createElement('div'); node.textContent = value; return node.innerHTML; }
      render(cart) {
        document.querySelectorAll('[data-cart-count]').forEach((count) => count.textContent = `(${cart.item_count})`);
        this.querySelector('[data-drawer-count]').textContent = `(${cart.item_count})`;
        this.querySelector('[data-drawer-total]').textContent = this.money(cart.total_price, cart.currency);
        this.footer.hidden = cart.item_count === 0;
        this.renderProgress(cart);
        if (!cart.items.length) { this.items.innerHTML = `<div class="rf-drawer__empty"><p>${this.escape(this.dataset.emptyMessage)}</p><a href="/collections/all">Continue shopping</a></div>`; return; }
        this.items.innerHTML = cart.items.map((item) => `<article class="rf-drawer__item"><a href="${item.url}"><img src="${item.image || ''}" alt="${this.escape(item.product_title)}"></a><div><a href="${item.url}"><h3>${this.escape(item.product_title)}</h3></a>${item.variant_title ? `<p class="rf-drawer__item-variant">${this.escape(item.variant_title)}</p>` : ''}<div class="rf-drawer__quantity" aria-label="${this.escape(this.dataset.quantityLabel)}"><button type="button" data-cart-quantity data-key="${this.escape(item.key)}" data-quantity="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity data-key="${this.escape(item.key)}" data-quantity="${item.quantity + 1}">+</button></div><button type="button" class="rf-drawer__remove" data-cart-remove data-key="${this.escape(item.key)}">${this.escape(this.dataset.removeLabel)}</button></div><strong>${this.money(item.final_line_price, cart.currency)}</strong></article>`).join('');
        this.querySelectorAll('[data-recommendation]').forEach((card) => { card.hidden = cart.items.some((item) => String(item.product_id) === card.dataset.productId); });
      }
      renderProgress(cart) {
        const threshold = Number(this.dataset.threshold || 0);
        const progress = this.querySelector('[data-delivery-progress]');
        if (!threshold) { progress.hidden = true; return; }
        progress.hidden = false;
        const remaining = Math.max(0, threshold - cart.total_price);
        const copy = remaining === 0 ? this.dataset.freeMessage : this.dataset.progressMessage.replace('[amount]', this.money(remaining, cart.currency));
        this.querySelector('[data-progress-copy]').textContent = copy;
        this.querySelector('[data-progress-bar]').style.width = `${Math.min(100, cart.total_price / threshold * 100)}%`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roseford-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rf-header]').forEach((header) => {
    const desktopMenus = header.querySelectorAll('[data-rf-desktop-menu]');
    const mobileMenu = header.querySelector('[data-rf-mobile-dialog]');
    const mobileTrigger = header.querySelector('[data-rf-mobile-open]');
    desktopMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        desktopMenus.forEach((other) => {
          if (other !== menu) other.removeAttribute('open');
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) desktopMenus.forEach((menu) => menu.removeAttribute('open'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      desktopMenus.forEach((menu) => menu.removeAttribute('open'));
      if (mobileMenu?.open) mobileMenu.close();
    });
    mobileTrigger?.addEventListener('click', () => {
      mobileMenu?.showModal();
      mobileTrigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    });
    mobileMenu?.addEventListener('close', () => {
      mobileTrigger?.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    });
    header.querySelectorAll('[data-rf-mobile-close]').forEach((control) => {
      control.addEventListener('click', () => mobileMenu?.close());
    });
    mobileMenu?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => mobileMenu.close());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roseford-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('roseford-product')) {
    customElements.define('roseford-product', class extends HTMLElement {
      connectedCallback() {
        this.quantity = this.querySelector('input[name="quantity"]');
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
        this.select = this.querySelector('[data-variant-select]');
        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        this.select?.addEventListener('change', () => this.updateVariant());
        this.optionSelects = [...this.querySelectorAll('[data-option-select]')];
        this.optionSelects.forEach((option) => option.addEventListener('change', () => this.selectOptions()));
        this.querySelector('[data-mobile-submit]')?.addEventListener('click', () => this.querySelector('[data-add-to-cart]')?.click());
      }
      changeQuantity(change) {
        const next = Math.max(1, Number(this.quantity.value || 1) + change);
        this.quantity.value = next;
      }
      selectOptions() {
        const selectedOptions = this.optionSelects.map((option) => option.value);
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
        if (!variant || !this.select) return;
        this.select.value = variant.id;
        this.updateVariant();
      }
      updateVariant() {
        const variant = this.variants.find((item) => String(item.id) === this.select.value);
        if (!variant) return;
        const submit = this.querySelector('[data-add-to-cart]');
        const label = this.querySelector('[data-add-label]');
        const currentPrice = this.querySelector('[data-current-price]');
        const comparePrice = this.querySelector('[data-compare-price]');
        const buttonPrice = this.querySelector('[data-button-price]');
        const mobilePrice = this.querySelector('[data-mobile-price]');
        const mobileSubmit = this.querySelector('[data-mobile-submit]');
        const saleBadge = this.querySelector('[data-sale-badge]');
        if (currentPrice) currentPrice.textContent = variant.price;
        if (buttonPrice) buttonPrice.textContent = variant.price;
        if (mobilePrice) mobilePrice.textContent = variant.price;
        if (comparePrice) {
          comparePrice.textContent = variant.compare_at_price;
          comparePrice.hidden = !variant.show_compare;
        }
        if (submit) submit.disabled = !variant.available;
        if (label) label.textContent = variant.available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
        if (mobileSubmit) {
          mobileSubmit.disabled = !variant.available;
          mobileSubmit.textContent = variant.available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
        }
        if (saleBadge) saleBadge.hidden = !variant.show_compare;
        window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
